import React from 'react';
import styled from 'styled-components';
import { blueColor } from 'js/config/style';
import { lineHeight, verticalPadding, horizontalPadding } from 'js/components/common/Button/style';

const Button = styled.button`
  display: block;
  width: 100%;
  background: transparent;
  color: ${blueColor};
  box-shadow: none;
  border: 1px solid ${blueColor};
  line-height: ${lineHeight}rem;
  padding: ${verticalPadding}rem ${horizontalPadding}rem;
  border-radius: 0.25rem;
  cursor: pointer;
  font-weight: 500;

  &:active {
    box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.3) inset;
  }
`;

export default props => <Button {...props} />;
